import { AsyncThunkAction } from 'actions/actions.types'
import { chatPath, contactPath } from 'components/paths'
import { mergeAllUrls } from 'functions/mergeAllUrls'
import { push } from 'functions/router'

export const pushToChatAction =
  (userId: number): AsyncThunkAction =>
  (dispatch) => {
    dispatch(push(mergeAllUrls(chatPath, userId, contactPath)))
  }
